/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsHoopCategory,
    MelcoModelsHoopCategoryFromJSON,
    MelcoModelsHoopCategoryFromJSONTyped,
    MelcoModelsHoopCategoryToJSON,
    MelcoModelsHoopMachine,
    MelcoModelsHoopMachineFromJSON,
    MelcoModelsHoopMachineFromJSONTyped,
    MelcoModelsHoopMachineToJSON,
    MelcoModelsHoopProduct,
    MelcoModelsHoopProductFromJSON,
    MelcoModelsHoopProductFromJSONTyped,
    MelcoModelsHoopProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsCreateHoop
 */
export interface MelcoModelsCreateHoop {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateHoop
     */
    english_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateHoop
     */
    metric_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsCreateHoop
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsCreateHoop
     */
    width_points?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsCreateHoop
     */
    height_points?: number;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateHoop
     */
    presser_foot?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsCreateHoop
     */
    enable_templates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateHoop
     */
    backward_compatibility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateHoop
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsCreateHoop
     */
    discontinued?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateHoop
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateHoop
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {Array<MelcoModelsHoopCategory>}
     * @memberof MelcoModelsCreateHoop
     */
    category_list?: Array<MelcoModelsHoopCategory> | null;
    /**
     * 
     * @type {Array<MelcoModelsHoopProduct>}
     * @memberof MelcoModelsCreateHoop
     */
    product_list?: Array<MelcoModelsHoopProduct> | null;
    /**
     * 
     * @type {Array<MelcoModelsHoopMachine>}
     * @memberof MelcoModelsCreateHoop
     */
    machine_list?: Array<MelcoModelsHoopMachine> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsCreateHoop
     */
    publish_state?: number;
}

export function MelcoModelsCreateHoopFromJSON(json: any): MelcoModelsCreateHoop {
    return MelcoModelsCreateHoopFromJSONTyped(json, false);
}

export function MelcoModelsCreateHoopFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCreateHoop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'english_name': !exists(json, 'english_name') ? undefined : json['english_name'],
        'metric_name': !exists(json, 'metric_name') ? undefined : json['metric_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'width_points': !exists(json, 'width_points') ? undefined : json['width_points'],
        'height_points': !exists(json, 'height_points') ? undefined : json['height_points'],
        'presser_foot': !exists(json, 'presser_foot') ? undefined : json['presser_foot'],
        'enable_templates': !exists(json, 'enable_templates') ? undefined : json['enable_templates'],
        'backward_compatibility_id': !exists(json, 'backward_compatibility_id') ? undefined : json['backward_compatibility_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'discontinued': !exists(json, 'discontinued') ? undefined : json['discontinued'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'category_list': !exists(json, 'category_list') ? undefined : (json['category_list'] === null ? null : (json['category_list'] as Array<any>).map(MelcoModelsHoopCategoryFromJSON)),
        'product_list': !exists(json, 'product_list') ? undefined : (json['product_list'] === null ? null : (json['product_list'] as Array<any>).map(MelcoModelsHoopProductFromJSON)),
        'machine_list': !exists(json, 'machine_list') ? undefined : (json['machine_list'] === null ? null : (json['machine_list'] as Array<any>).map(MelcoModelsHoopMachineFromJSON)),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
    };
}

export function MelcoModelsCreateHoopToJSON(value?: MelcoModelsCreateHoop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'english_name': value.english_name,
        'metric_name': value.metric_name,
        'version': value.version,
        'width_points': value.width_points,
        'height_points': value.height_points,
        'presser_foot': value.presser_foot,
        'enable_templates': value.enable_templates,
        'backward_compatibility_id': value.backward_compatibility_id,
        'type': value.type,
        'discontinued': value.discontinued,
        'supplier_id': value.supplier_id,
        'supplier_product_id': value.supplier_product_id,
        'category_list': value.category_list === undefined ? undefined : (value.category_list === null ? null : (value.category_list as Array<any>).map(MelcoModelsHoopCategoryToJSON)),
        'product_list': value.product_list === undefined ? undefined : (value.product_list === null ? null : (value.product_list as Array<any>).map(MelcoModelsHoopProductToJSON)),
        'machine_list': value.machine_list === undefined ? undefined : (value.machine_list === null ? null : (value.machine_list as Array<any>).map(MelcoModelsHoopMachineToJSON)),
        'publish_state': value.publish_state,
    };
}


